<sdds-modal size="sm" selector="#areYouSureModal" prevent>
    <h5 slot="sdds-modal-headline">Are you sure?</h5>

    <p slot="sdds-modal-body">{{message}}</p>

    <button slot="sdds-modal-actions" data-dismiss-modal class="sdds-btn sdds-btn-primary sdds-btn-md mr-12" (click)="yes()">Yes</button>
    <button slot="sdds-modal-actions" data-dismiss-modal class="sdds-btn sdds-btn-secondary sdds-btn-md" (click)="no()">No</button>
</sdds-modal>
